import type { UserWithRoles } from './types'

/**
 * Bir kullanıcı satırının **gösterim adı**: ad soyad → kullanıcı adı → e-posta.
 *
 * <p><b>Neden tek kaynak.</b> Aynı zincir üç yerde birden kullanılıyor: kart başlığı
 * (`UsersAdminPage`), masaüstü tablonun satır eylemleri (`UserColumns`) ve kart dalındaki eylemler.
 * Erişilebilir adda (`rowActionLabel`) kullanılan ad ile ekranda **görünen** ad ayrışırsa, ekran
 * okuyucu kullanıcısı ile görsel kullanıcı aynı satırdan söz ettiklerini anlayamaz — sesli kontrolde
 * de "X kullanıcısının rollerini düzenle" komutu ekranda X yazmayan bir satıra gider.
 *
 * <p>Dördü de boşsa boş dize döner; çağıran {@code rowActionLabel} bunu adsız anahtara düşürür
 * ("Roller"), çünkü " kullanıcısının rollerini düzenle" gibi baştan boşluklu bir ad ne okunabilir
 * ne ayırt edicidir.
 */
export function userDisplayName(row: Pick<UserWithRoles, 'name' | 'surname' | 'userName' | 'email'>): string {
  return [row.name, row.surname].filter(Boolean).join(' ') || row.userName || row.email || ''
}
